import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { mainnet, sepolia } from 'viem/chains'
import { buildMainnetTransport, buildSepoliaTransport } from './rpcTransports'

// RainbowKit throws if projectId is empty — the app would not render (blank dark screen).
// Official demo ID (same as RainbowKit's YOUR_PROJECT_ID placeholder); set VITE_WALLETCONNECT_PROJECT_ID in .env for your own WalletConnect Cloud project in production.
const DEMO_WALLETCONNECT_PROJECT_ID = '21fef48091f12692cad574a6f7753643'

const walletConnectProjectId =
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim() || DEMO_WALLETCONNECT_PROJECT_ID

export const wagmiConfig = getDefaultConfig({
  appName: 'Kavachswap',
  projectId: walletConnectProjectId,
  chains: [mainnet, sepolia],
  ssr: false,
  transports: {
    [mainnet.id]: buildMainnetTransport(),
    [sepolia.id]: buildSepoliaTransport(),
  },
})
